import { setCurrentConversation } from "../currentConversation/setCurrentConversation"

export const FETCH_CONVERSATIONS_BEGIN   = "FETCH_CONVERSATIONS_BEGIN"
export const FETCH_CONVERSATIONS_SUCCESS = "FETCH_CONVERSATIONS_SUCCESS"
export const FETCH_CONVERSATIONS_FAILED  = "FETCH_CONVERSATIONS_FAILED"

const fetchConversationBeginAction   =  (payload) => ({ type: FETCH_CONVERSATIONS_BEGIN, payload })
const fetchConversationSuccessAction =  (payload) => ({ type: FETCH_CONVERSATIONS_SUCCESS, payload })
const fetchConversationBeginFailed   =  (payload) => ({ type: FETCH_CONVERSATIONS_FAILED, payload })

export const fetchConversations = (shouldSetCurrentConversation=false, showLoading=true) => {
  return (dispatch, getState) => {
    const { organization } = getState()
    dispatch(fetchConversationBeginAction({ loading: showLoading}))
    return $.ajax({
      url: `/api/staff/v1/conversations.json`,
      success:  response => {
        dispatch(fetchConversationSuccessAction(response))
        if (shouldSetCurrentConversation) dispatch(setCurrentConversation(response[0]))
      },
      error: () => dispatch(fetchConversationBeginFailed())
    })
  }
}